import React from 'react'
import PageWrapper from '../Components/Other/PageWrapper'
import { useEffect } from 'react';
import PageBanner from '../Components/Other/PageBanner'
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment'
import { CommonApiFun } from '../Redux/Action/index'
function Careers(props) {
    const dispatch = useDispatch()
    var careersArr = useSelector((state) => state.careersArr)

    useEffect(() => {
        var data = { action: "career" }
        dispatch(CommonApiFun("api/Api_controller/post", JSON.stringify(data))).then((res) => {
          
            dispatch({ type: 'CAREERS_DATA', payload: res.data })

        }).catch((e) => {
            
        })
    }, [])
    return (
        <PageWrapper className={"blog-page"}>
            <div className="pageWrapper">
                <PageBanner pageName={"Careers"}></PageBanner>
                <div className="MainContent">
                    <div className="container">
                        <div className="row news-wrapper article-grid">
                            <div className="news_wrap">
                                <div className="news_box">
                                    {careersArr.length == 0 && <div className='loader-box'><div className="loader"></div></div>}
                                    {
                                        careersArr.map((item, index) => {
                                            return (
                                                <div className="careers_box">
                                                    <div className="careers_box-item">
                                                        <div className="careers_inner">
                                                            <div className="info_img">
                                                                <div className="careers_list">
                                                                    <a
                                                                        href="<?php echo $site_link;?>/team-detail-01.php"
                                                                        className="link"
                                                                    >
                                                                        {item.name}
                                                                    </a>
                                                                    <span>
                                                                        <b>Positions : </b>{item.position}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="info_middle">
                                                                <ul className="listUnstyle">
                                                                    <li>
                                                                        <b>Qualification : </b>{item.education}
                                                                    </li>
                                                                    <li>
                                                                        <b>Experience : </b> {item.experience}
                                                                    </li>
                                                                    <li>
                                                                        <b>Work Location : </b> {item.location}
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <div className="info_bottom">
                                                                {item.skills !== '' && <ul className="listUnstyle">
                                                                    <li>
                                                                        <b>Roles and Responsibilities :</b>
                                                                    </li>
                                                                    {item.skills.map((data) => (
                                                                        <li>
                                                                            {data}
                                                                        </li>
                                                                    ))}
                                                                </ul>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        )
                                    }
                                </div>
                                <div className="careers_why_ansh pad-60">
                                    <div className="container">
                                        <h2>Why Ansh Homeopathy</h2>
                                        <div className="row">
                                            <ul>
                                                <li className="why_ansh_slide">
                                                    <div className="why_ansh_content">
                                                        <div className="ansh_icon">
                                                            <picture>
                                                                <img alt="" src="" />
                                                            </picture>
                                                        </div>
                                                        <h3>Work Environment</h3>
                                                        <p>
                                                            We are as respectful, friendly, helpful, and supportive to one
                                                            another as we are to our patients. Administrators seek to treat
                                                            employees in the same way that employees treat patients.
                                                        </p>
                                                    </div>
                                                </li>
                                                <li className="why_ansh_slide">
                                                    <div className="why_ansh_content">
                                                        <div className="ansh_icon">
                                                            <picture>
                                                                <img alt="" src="" />
                                                            </picture>
                                                        </div>
                                                        <h3>commitment</h3>
                                                        <p>
                                                            We have a commitment to serving the community and providing open
                                                            access to Grace Health for all community members.
                                                        </p>
                                                    </div>
                                                </li>
                                                <li className="why_ansh_slide">
                                                    <div className="why_ansh_content">
                                                        <div className="ansh_icon">
                                                            <img alt="" src="" />
                                                        </div>
                                                        <h3>Health Care</h3>
                                                        <p>
                                                            We care for the whole person, see the complexity of each person’s
                                                            life, and believe that addressing a broad range of human needs is
                                                            the best way to improve a person’s health
                                                        </p>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PageWrapper>
    );
}

export default Careers;